import { intl } from "LocaleWrapper";
import { useApolloClient, useMutation } from "@apollo/client";
import { QuickFilterTypes, Table } from "@cofano/cck";
import DeleteIcon from "@mui/icons-material/Delete";
import { TableId, useBackendTable } from "components/table";
import { useConfirm } from "components/hooks/useConfirm";
import { GetCargoTemplatesDocument } from "__generated__/view/templates/graphql/template.queries.generated";
import { DeleteCargoTemplateDocument } from "__generated__/view/templates/graphql/template.mutations.generated";

const TemplateCargoTable = () => {

	const confirm = useConfirm();
	const client = useApolloClient();

	const [ deleteCargoTemplate ] = useMutation(DeleteCargoTemplateDocument);

	const { tableProps, refetch } = useBackendTable({
		id: TableId.Cargos,
		onChange: async (pagination, sort, filter, callback) => {
			try {
				const result = await client.query({
					query: GetCargoTemplatesDocument,
					variables: {
						pagination: {
							...pagination,
						},
						search: {
							description: filter.templateDescription ? [ filter.templateDescription ] : undefined,
						},
					},
				});

				callback({
					content: result.data?.cargoTemplates.content ?? [],
					totalResults: result.data?.cargoTemplates?.totalElements ?? 0,
				});
			} catch {
				callback({
					content: [],
					totalResults: 0,
				});
			}
		},
	});

	const deleteTemplate = (id: number) => {
		deleteCargoTemplate({
			variables: {
				id: id,
			},
		}).then(() => {
			refetch();
		});
	};

	return (
		<Table
			{...tableProps}
			columns={[ {
				id: "templateDescription",
				title: intl.formatMessage({ id: "DESCRIPTION" }),
				sortable: true,
				filterComponent: QuickFilterTypes.TEXT,
			} ]}
			rowActions={[ {
				icon: <DeleteIcon />,
				onClick: (row) => {
					confirm({
						type: "DELETE",
					}).then(() => {
						deleteTemplate(row.id);
					});
				},
			} ]} />
	);
};

export default TemplateCargoTable;
